import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 4.5rem;
`;

export const Sidebar = styled.div``;

export const Main = styled.div`
  flex: 1;
`;

export const NotFoundText = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
`;
